export const myKeys = {
  myCommunity: ['myCommunity-'] as const,
  myProfileSummary: ['myProfileSummary-'] as const,
  myBadges: ['myBadges-'] as const,
  myPointShopList: ['myPointShopList-'] as const,
  myCoupon: ['myCoupon-'] as const,
  myThanksLetter: ['myThanksLetter-'] as const,
  myDonationList: ['myDonationList-'] as const,
};
